module.exports = __webpack_public_path__ + "media/images/landing/second/photo22-a3be6ef157fa0393e3b0994e784405ed.jpg";